<template>
  <v-app>
    <v-card elevation="1" class="custom-card">
      <BaseHeader>
        <v-flex offset-xs6 offset-sm9>
          <v-select
            v-model="language"
            :items="languages"
            class="pa-0 ma-0"
            hide-details
          ></v-select>
        </v-flex>
      </BaseHeader>

      <v-layout row wrap pb-3 class="main-wrapper">
        <PaymentDetails></PaymentDetails>
        <v-flex
          xs12
          sm6
          pa-3
          pl-4
          :class="{ 'pr-5': $vuetify.breakpoint.smAndUp }"
        >
          <v-flex class="pb-3 custom_text_18">
            {{ text.title }}
          </v-flex>

          <Paying
            :to="
              `/paymentInput/${params.method}/?linkcode=${
                $route.query.linkcode
              }`
            "
            :edit="editable"
          ></Paying>
          <form id="payment-form" style="height: 0px;">
            <input
              v-model="credit.cardnumber"
              type="hidden"
              data-encrypt="cardnumber"
            /><br />
            <input
              v-model="credit.expmonth"
              type="hidden"
              data-encrypt="month"
            /><br />
            <input
              v-model="credit.expyear"
              type="hidden"
              data-encrypt="year"
            /><br />
            <input
              v-model="credit.cvv"
              type="hidden"
              data-encrypt="cvv"
            /><br />
            <input type="hidden" value="" name="encryptedCardInfo" />
            <input type="hidden" value="" name="maskedCardInfo" />
            <input type="hidden" value="" name="expMonthCardInfo" />
            <input type="hidden" value="" name="expYearCardInfo" />
          </form>
          <form
            :action="formAction"
            method="POST"
            name="paymentRequestForm"
            ref="paymentRequestForm"
          >
            <input
              v-model="paymentRequest"
              type="hidden"
              id="paymentRequest"
              name="paymentRequest"
              ref="paymentRequest"
            />
          </form>
          <v-flex class="pb-2 caption font-weight-bold">
            {{ text.cardTitle }}
          </v-flex>
          <!-- <v-radio-group
            v-model="selectedCard"
            class="mt-0 fullwidth"
            hide-details
          >
            <v-radio
              v-for="(card, index) in storedCard"
              :key="index"
              :label="card.cardMark"
              :value="card.id"
              class="pa-3"
              style="border-width: 1.5px; border-style: solid; border-color: rgba(0,0,0,0.1); border-radius:4px; width: 100%"
            ></v-radio>
            <v-radio
              :label="text.newCard"
              :value="0"
              class="pa-3"
              style="border-width: 1.5px 1.5px 0 1.5px; border-style: solid; border-color: rgba(0,0,0,0.1); border-radius: 4px 4px 0 0; width: 100%"
            ></v-radio>
          </v-radio-group> -->
          <InputCredit
            v-model="credit"
            class="pa-3 mb-2"
            :disabled="selectedCard != 0"
            style="border-width: 1.5px 1.5px 1.5px 1.5px; border-style: solid; border-color: rgba(0,0,0,0.1); border-radius: 0 0 4px 4px;"
          ></InputCredit>

          <change-payment-method />

          <v-flex>
            <v-btn
              block
              round
              large
              color="primary"
              :disabled="!credit.complete && selectedCard == 0"
              @click="submitCreditCard"
            >
              {{ text.next }}
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>

      <BaseFooter :selected_payment_method="false"></BaseFooter>
    </v-card>
  </v-app>
</template>

<script>
/*eslint no-undef: "off"*/
export default {
  data() {
    console.log(
      'process.env.VUE_APP_TWOCTWOP_PAYMENT_AUTH_URL',
      process.env.VUE_APP_TWOCTWOP_PAYMENT_AUTH_URL
    )
    return {
      // /prod
      // formAction: 'https://t.2c2p.com/SecurePayment/PaymentAuth.aspx',

      // /dev

      // 'https://demo2.2c2p.com/2C2PFrontEnd/SecurePayment/PaymentAuth.aspx'
      formAction: process.env.VUE_APP_TWOCTWOP_PAYMENT_AUTH_URL,
      credit: {
        amount: 0,
        cardname: '',
        cardnumber: '',
        expmonth: '',
        expyear: '',
        cvv: '',
        savecard: false
      },
      languages: ['ไทย', 'อังกฤษ', 'จีน'],
      language: 'ไทย',
      params: this.$route.params,
      selectedCard: 0
    }
  },
  computed: {
    storedCard() {
      return this.$store.state.storedCard
    },

    paymentRequest() {
      return this.$store.state.paymentRequest
    },

    editable() {
      if (this.$store.state.billBank) {
        let banks = this.$store.state.billBank
        let selectedBank = banks.filter(bank => {
          return bank.paymentType == this.params.method
        })[0]
        if (selectedBank) return selectedBank.splitCard
      }
      return false
    },

    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          title: 'Credit/Debit Card',
          cardTitle: 'Credit/Debit Card Information',
          newCard: 'other card',
          next: 'Next'
        }
      } else {
        obj = {
          title: 'บัตรเครดิต/เดบิต',
          cardTitle: 'ข้อมูลบัตรเครดิต / เดบิต',
          newCard: 'เพิ่มบัตรใหม่',
          next: 'ชำระเงิน'
        }
      }
      return obj
    }
  },
  methods: {
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    },
    submitCreditCard() {
      if (this.selectedCard == 0) {
        console.log(222)
        new Promise((resolve, reject) => {
          My2c2p.getEncrypted(
            'payment-form',
            (encryptedData, errCode, errDesc) => {
              if (errCode != 0) {
                reject(errDesc + ' (' + errCode + ')')
              } else {
                resolve(encryptedData)
              }
            }
          )
        })
          .then(encryptedData => {
            let creditData = Object.assign({}, this.credit)
            creditData.cardnumber = encryptedData.encryptedCardInfo
            creditData.markcardinfo = encryptedData.maskedCardInfo
            this.$store.dispatch('submitCreditCard', creditData).then(() => {
              this.$refs.paymentRequestForm.submit()
            })
          })
          .catch(error => {
            alert(error.message)
          })
      } else {
        let creditData = {
          amount: this.$store.state.amount,
          cardid: this.selectedCard
        }
        this.$store.dispatch('submitCreditCard', creditData).then(() => {
          this.$refs.paymentRequestForm.submit()
        })
      }
    }
  }
}
</script>
